import React, {useEffect, useState} from 'react';
import colors from '../../../../../../util/colors';
import {Icons} from '../../../../../../util/icons';
import {strings} from '../../../../../../util/strings';
import AppButton from '../../../../../app-button';
import Icon from '../../../../../icon';
import {Column, Row} from '../../../../../layout';
import ModalTemplate from '../../../../../modal';
import * as fonts from '../../../../../../util/fonts';
import {compose} from 'redux';
import {connect} from 'react-redux';

interface DataNotFoundModalProps {
  showDataNotFound: any;
  labels: typeof strings.pt.virtualCard;
  setShowDataNotFound(value: any): void;
  renderHeaderCard?(): void;
}

function DataNotFoundModal({
  showDataNotFound,
  labels,
  setShowDataNotFound,
  renderHeaderCard,
}: DataNotFoundModalProps) {
  return (
    <ModalTemplate
      hideFooter={true}
      cross={true}
      centered={false}
      show={showDataNotFound}
      className="data-not-found-modal"
      title={labels?.changeInsuranceData_title}
      titleStyle={{...fonts.L, ...fonts.SemiBold}}
      onHide={() => {
        setShowDataNotFound(false);
      }}
      size="lg">
      <Row>
        <Icon
          name={Icons.ALERT_TIME}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          changeViewbox={true}
          color={colors.alertRed}
        />
      </Row>
      <Column
        className="data-not-found-description"
        style={{
          ...fonts.MM,
          ...fonts.Bold,
          color: colors.alertRed,
        }}>
        {labels?.VCErrorNotFound_title}
      </Column>
      <Row className="confirm-button">
        <AppButton
          className="app-drag-drop-select-button"
          variant="secondary"
          onClick={() => {
            setShowDataNotFound(false);
            if (renderHeaderCard) {
              renderHeaderCard();
            }
          }}>
          {labels?.changeInsuranceData_ageError_button_web}
        </AppButton>
      </Row>
    </ModalTemplate>
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.virtualCard,
});

export default compose(connect(mapStateToProps)(DataNotFoundModal));
